var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileDemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_16242)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "url(#paint0_radial_0_16242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 13.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "#FF4300",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 61.5C56.5 51.0066 47.9934 42.5 37.5 42.5C27.0066 42.5 18.5 51.0066 18.5 61.5",
    stroke: "#FF4300",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_16242",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5 37.5) rotate(90) scale(37.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488472,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_16242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDemo);
export default __webpack_public_path__ + "static/media/ProfileDemo.42beb05802cc3d87fa9ad414e58cce43.svg";
export { ForwardRef as ReactComponent };